import axios from 'axios';
import moment from 'moment';

export const GET_LIST_GENERAL_NOTES = '/generalNotes/getList';
export const GET_DETAILS_GENERAL_NOTE = '/generalNotes/getDetails';
export const ADD_EDIT_GENERAL_NOTE = '/generalNotes/addEdit';
export const DELETE_GENERAL_NOTE = '/generalNotes/delete';
export const GET_GENERAL_NOTE_STATUS_TYPES = '/generalData/getGeneralNoteStatusTypes';

export const getList = async (shumaID) => {
  const data = {shumaID};

  const response = await axios.post(GET_LIST_GENERAL_NOTES, data);
  const {errorCode, body} = response.data;

  if (errorCode < 0) {
    throw new Error();
  }

  return body?.list;
};

export const getDetails = async (generalNoteID) => {
  const data = {
    generalNoteID: parseInt(generalNoteID, 10),
  };

  const response = await axios.post(GET_DETAILS_GENERAL_NOTE, data);
  const {errorCode, body} = response.data;

  if (errorCode < 0) {
    throw new Error();
  }

  return body?.generalNote || null;
};

export const addEditNote = async ({
                                    generalNoteID = -1,
                                    shumaID,
                                    statusTypeID,
                                    dueDate,
                                    responsibleUserID,
                                    freeText,
                                  }) => {
  const data = {
    generalNoteID: parseInt(generalNoteID, 10),
    shumaID: parseInt(shumaID, 10),
    statusTypeID: parseInt(statusTypeID, 10),
    dueDate: dueDate ? moment(dueDate).format('YYYY-MM-DD') : null,
    responsibleUserID: responsibleUserID
      ? parseInt(responsibleUserID, 10)
      : null,
    freeText,
  };

  const response = await axios.post(ADD_EDIT_GENERAL_NOTE, data);
  const {errorCode} = response.data;

  if (errorCode < 0) {
    throw new Error();
  }
};

export const deleteNote = async (id) => {
  const data = {
    generalNoteID: parseInt(id, 10),
  };

  const response = await axios.post(DELETE_GENERAL_NOTE, data);
  const {errorCode} = response.data;

  if (errorCode < 0) {
    throw new Error();
  }
};

export const getNoteStatusTypes = async () => {
  const response = await axios.get(GET_GENERAL_NOTE_STATUS_TYPES);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body?.generalNoteStatusTypes ? body.generalNoteStatusTypes : [];
  }
};